/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProgramsRouteImport } from './routes/programs'
import { Route as PlayRouteImport } from './routes/play'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as IndexRouteImport } from './routes/index'

const ProgramsRoute = ProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutUsRoute = AboutUsRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about-us': typeof AboutUsRoute
  '/login': typeof LoginRoute
  '/play': typeof PlayRoute
  '/programs': typeof ProgramsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about-us': typeof AboutUsRoute
  '/login': typeof LoginRoute
  '/play': typeof PlayRoute
  '/programs': typeof ProgramsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about-us': typeof AboutUsRoute
  '/login': typeof LoginRoute
  '/play': typeof PlayRoute
  '/programs': typeof ProgramsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/about-us' | '/login' | '/play' | '/programs'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/about-us' | '/login' | '/play' | '/programs'
  id: '__root__' | '/' | '/about-us' | '/login' | '/play' | '/programs'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutUsRoute: typeof AboutUsRoute
  LoginRoute: typeof LoginRoute
  PlayRoute: typeof PlayRoute
  ProgramsRoute: typeof ProgramsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/programs': {
      id: '/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof ProgramsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutUsRoute: AboutUsRoute,
  LoginRoute: LoginRoute,
  PlayRoute: PlayRoute,
  ProgramsRoute: ProgramsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
